import React, { useState, useCallback } from "react";
import AlertContext from "./AlertContext";
import { GenerateGUID } from "../../modules/guid";

const AlertContextProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = useCallback(
    (alertText, alertColor) => {
      const id = GenerateGUID();
      const newAlert = { alertText, alertColor, id };
      let newAlertsArray = [...alerts];
      newAlertsArray.splice(0, 0, newAlert);

      setAlerts(newAlertsArray);
    },
    [alerts]
  );

  const showFailureAlert = (alertText) => showAlert(alertText, "danger");
  const showSuccessAlert = (alertText) => showAlert(alertText, "success");
  const showWarningAlert = (alertText) => showAlert(alertText, "warning");

  return (
    <AlertContext.Provider
      value={{
        alerts,
        setAlerts,
        showFailureAlert,
        showSuccessAlert,
        showWarningAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContextProvider;
